'use client';

import { useRouter } from 'next/router';
import { useEmRegionFilters } from '@/creditflowresearch/application/PageFilters/hooks/useEmRegionFilters';
import type { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { transformToFilterSets } from './helpers/transformToFilterSets';

export const useEmMarketArticlesFilters = (): IFilterSet[] => {
  const { query } = useRouter();
  const regions = useEmRegionFilters();

  return transformToFilterSets([
    { key: 'regions', items: regions },
  ], query);
};
